export type ValuePickerExtra = {
    Component: string
    Props?: Record<string, any>
}

export enum EValuePickerExtraComponent {
    InfoTextLabel = 'InfoTextLabel',
    HelperText = 'HelperText',
}
